import {
  ProfileClickAction,
  ProfileCoverImageUploadedAction,
  ProfileCreatedAction,
  ProfileImageUploadedAction,
  ProfileSimilarCreatorCriteriaAction,
  ProfileUpdatedAction,
  UserAction
} from '../../types/user-actions';

export const isProfileClickAction = (
  action?: UserAction
): action is ProfileClickAction => (
  action !== undefined
  && action.eventCategory === 'profile'
  && action.eventAction === 'click'
);

export const isProfileCreatedAction = (
  action?: UserAction
): action is ProfileCreatedAction => (
  action !== undefined
  && action.eventCategory === 'profile'
  && action.eventAction === 'profile-created'
);

export const isProfileUpdatedAction = (
  action?: UserAction
): action is ProfileUpdatedAction => (
  action !== undefined
  && action.eventCategory === 'profile'
  && action.eventAction === 'profile-updated'
);

export const isProfileCoverImageUploadedAction = (
  action?: UserAction
): action is ProfileCoverImageUploadedAction => (
  action !== undefined
  && action.eventCategory === 'profile'
  && action.eventAction === 'profile-cover-image-uploaded'
);

export const isProfileImageUploadedAction = (
  action?: UserAction
): action is ProfileImageUploadedAction => (
  action !== undefined
  && action.eventCategory === 'profile'
  && action.eventAction === 'profile-image-uploaded'
);

export const isProfileSimilarCreatorCriteriaAction = (
  action?: UserAction
): action is ProfileSimilarCreatorCriteriaAction => (
  action !== undefined
  && action.eventCategory === 'profile'
  && action.eventAction === 'influencer-profile-similar-creator-criteria-changed'
);
